import React, {Fragment} from "react";
import ContainerFotoArchivio from "./ContainerFotoArchivio";
import ModalAddTitoloArchivio from "./ModalAddTitoloArchivio";

export default function ContenutoTitoloArchivioView({
                                                        titoli,
                                                        isRuoloAd,
                                                        openModalAddTitolo,
                                                        closeModalAddTitolo,
                                                        addTitoloOk,
                                                        showModalAddDoc,
                                                        selectTitolo,
                                                        idMarca,
                                                    }) {

    return (
        <Fragment>
            <ModalAddTitoloArchivio
                show={showModalAddDoc}
                handleClose={closeModalAddTitolo}
                submitOk={addTitoloOk}
                idMarca={idMarca}
            />
            <div className="row g-3">
                {
                    !isRuoloAd && titoli.length === 0 &&
                    <h5>Nessun documento caricato</h5>
                }
                {
                    isRuoloAd &&
                    <div className={"col-md-3"}>
                        <div
                            className={"ns-container-foto-upl ns-cursor-pointer ns-hover-shadow"}
                            onClick={openModalAddTitolo}
                        >
                            <div className={"ns-container-foto-archivio-label text-center"}>
                                <span aria-hidden="true">
                                    <div style={{
                                        height: "66px"
                                    }}>
                                        <h6>Aggiungi</h6>
                                    </div>
                                    <div className={"ns-foto"}>
                                        <div className={"ns-foto-img"}>
                                            <i className="fas fa-plus-circle" style={{fontSize: "6rem"}}></i>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                }
                {
                    titoli.map((f, idx) =>
                        <div className={"col-md-3"} key={idx}>
                            <ContainerFotoArchivio
                                idDocumento={f.id_archivio_titolo}
                                titolo={f.modello}
                                sottotitolo={f.anno_da || f.anno_a ? `${f.anno_da || ''} - ${f.anno_a || ''}` : ''}
                                nome={f.nome_file}
                                endpointContent={process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/${f.id_archivio_titolo}`}
                                handleOnClick={() => {
                                    selectTitolo(f);
                                }}
                            />
                        </div>
                    )
                }
            </div>
        </Fragment>
    );
}